var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgHws = function SvgHws(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.376,
    d: "M28.26 20.687V18.25a.584.584 0 0 0-.58-.557h-.595V14.23c0-2.585-2.104-4.7-4.702-4.7h-3.85a1.956 1.956 0 0 0-1.93-1.757h-1.188v-1.83h1.114c.52.495 1.2.767 1.918.767a2.76 2.76 0 0 0 2.76-2.759 2.76 2.76 0 0 0-2.76-2.758h-.037a2.8 2.8 0 0 0-1.881.767H10.7a2.74 2.74 0 0 0-1.868-.767h-.037a2.76 2.76 0 0 0-2.76 2.758 2.76 2.76 0 0 0 2.76 2.759c.717 0 1.398-.272 1.905-.767h1.114v1.83h-1.176c-1.014 0-1.843.78-1.93 1.757H3.51l-.05 6.098h5.248a1.94 1.94 0 0 0 1.93 1.756h5.965a1.954 1.954 0 0 0 1.93-1.756h2.463v2.065h-.594a.58.58 0 0 0-.581.57v2.411c0 .322.26.582.581.582h7.277c.31 0 .57-.26.582-.57z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2.376,
    d: "M24.09 30.817a2.61 2.61 0 0 1-2.61-2.61c0-1.682 1.967-3.772 2.202-4.007a.56.56 0 0 1 .408-.174c.161 0 .31.062.421.174.223.235 2.19 2.337 2.19 4.007a2.603 2.603 0 0 1-2.61 2.61z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHws);
export default ForwardRef;